import React, { useState } from 'react';
import styled,  { css } from 'styled-components';
import { fonts, colors } from './components/Styles';
import dollar from './components/Images/icon-dollar.svg'
import person from './components/Images/icon-person.svg'

const Container = styled.div`
    width: 100vw;
    background: ${colors.lightGray};
    height: 100vh;
    margin: auto;
    padding: 1em;
`
const AppContainer = styled.div`
    background: ${colors.white};
    border-radius: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 60em;
    height: auto;
    margin: auto;
    padding: 3em;
    @media (max-width: 575px) {
      display: flex;
      flex-direction: column;
    }
`
const VerticalFlex = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 20px;
    width: 30em;
    padding: 4em;
    margin: auto;
    justify-content: center;
    background:${props => props.primary ? `${colors.dark}` : `${colors.white}`};
    @media (max-width: 575px) {
      margin: 0;
    }
`
const HorizontalFlex = styled.div`
    display: flex;
    justify-content: space-between;
    flex-direction: row;
`

const Title = styled.div`
  width: 100%;
  color: ${colors.dark};
  font-size: ${fonts.large};
  font-weight: 400;
  line-height: 1;
  text-align: center;
  text-transform: uppercase;
  margin: 5em 0 2em 0;
  letter-spacing: 5px;
`
const InputContainer = styled.div`
  position: relative;
`

const TextInput = styled.input`
  font-size:${fonts.normal};
  color:${colors.primary};
  background-color:${colors.light};
  text-align: right;
  width: 100%;
  min-height: 40px;
  font-size: inherit;
  padding: 0 5px;
  border: ${props => props.error === true ? `1px solid ${colors.red}` : 'none' };
  border-radius: 10px;
  background-image: url(./components/Images/icon-dollar.svg);
  background-position: 7px 7px;
  background-repeat: no-repeat;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button{
    -webkit-appearance: none; 
    margin: 0; 
  }
  ${props => props.error && css`
    border: 3px solid red;
  `}
`
const RadioInput = styled.input`
  flex: 1 0 25%;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: ${props => props.custom ? `${colors.dark}` : props.clicked ? `${colors.dark}`: `${colors.light}` };
  background: ${props => props.custom ? `${colors.lightGray}` : props.clicked ? `${colors.primary}`: `${colors.dark}` };
  border-radius: 5px;
  height: 48px;
  border: none;
  width: 100%;
  cursor: pointer;
  margin: 0.1em;
`
const Label = styled.h4`
  font-size: inherit;
  color:${props => props.primary ? `${colors.white}` : `${colors.dark}`};
`
const Error = styled.div`
  margin: 0.1em;
  text-align: right;
  color:${colors.red};
`
const Span = styled.span`
  font-size: 0.8rem;
  color: ${colors.primary};
`
const Icon = styled.img`
left: 1rem;
position: absolute;
top: 80%;
transform: translateY(-50%);
z-index: 10;
`

const Amount = styled.h1`
  font-size:${fonts.extraLarge};
  color:${colors.primary};
  margin: 15px;
  &:hover{
    background-color:${colors.primary};
    color: ${colors.primary};
  }
`
const ResetButton = styled.button`
  padding: 1em;
  color: ${colors.dark};
  background: ${colors.primary};
  text-transform: uppercase;
  border-radius: 10px;
  border: none;
`

function App() {
  const [inputs, setInputs] = useState({
    bill: 0,
    tip: 0,
    amount:0,
    people: 1,
    percent: 0,
    custom: 0,
  })
  const [error, setError] = useState(false)


  const handleReset = () =>{
    setInputs({
      bill: 0,
      tip: 0,
      amount:0,
      people: 1,
      percent: 15,
      custom: 0,
    })
  }

  const calculateTip = () =>{
    inputs.tip = inputs.bill*inputs.percent/inputs.people
    inputs.amount = inputs.bill/inputs.people+inputs.tip
    setInputs({...inputs })
  }

  const handleSelect = (e) =>{
    inputs.percent = parseInt(e)/100
    setInputs({ ...inputs})
    calculateTip()
  }

  const handleInputChange = (e) =>{
    setError(false)
    if (e.target.name === "people" && (e.target.value === "0")) {
      return setError(true)
    } else{
      inputs[e.target.name] = e.target.value
      setInputs({...inputs})
      calculateTip()
      return
    }
  }

  return (
    <div className="App">
      <Container>
        <Title>spli <br />tter</Title>
        <AppContainer>
          <Bill 
            bill={inputs.bill}
            people={inputs.people}
            error={error}
            handleChange={(e)=>handleInputChange(e)}
            handleSelect={handleSelect}
          />
          <Results 
            tip={inputs.tip.toFixed(2)} 
            amount={inputs.amount.toFixed(2)}
            handleReset={handleReset}
          />
        </AppContainer>
      </Container>
    </div>
  );
}

const Bill = ({ people, bill, handleChange, handleSelect, error}) => {
  const [tipArr, setTipArr] = useState([
    { per : '5%', clicked: false},
    { per : '10%', clicked: false},
    { per : '15%', clicked: true},
    { per : '25%', clicked: false},
    { per : '50%', clicked: false},
    { per : 'custom', clicked: false}
  ])

  const handleActiveState = (t) =>{
    tipArr.forEach(tip => {
      if(tip.per === t){
        tip.clicked = true
      } else{
        tip.clicked = false
      }
    })
    setTipArr(tipArr)
  }

  return (
    <VerticalFlex>
      <InputContainer>
        <Label>Bill</Label>
        <Icon src={dollar} alt={'dollar'} />
        <TextInput type="number" name="bill" value={bill} onChange={(e) =>handleChange(e)} />
      </InputContainer>
      <Label>Select Tip %</Label>
      <HorizontalFlex
       style={{ flexWrap: 'wrap' }}>
         {tipArr.map((tip, index)=>{
          return(
            <RadioInput 
              key={index} 
              type="button" 
              onClick={() => {
                handleSelect(tip.per);
                handleActiveState(tip.per);
              }} 
              value={tip.per} 
              clicked={tip.clicked}/>
         )})}
      </HorizontalFlex>
      <InputContainer>
        <Label>Number of People</Label>
        {error && (
            <Error>{'Number of people cannot be < 1'}</Error>
          )}
        <Icon src={person} alt={'person'} />
        <TextInput 
          type="number" 
          name="people" 
          value={people} 
          onChange={handleChange}
          error={error}
          />
      </InputContainer>
    </VerticalFlex>
  )
}

const Results = ({tip, amount, handleReset}) => {
  return (
    <VerticalFlex primary>
      <HorizontalFlex>
        <Label primary>Tip Amount <br /> <Span>/person</Span> </Label>
        <Amount>$ {tip}</Amount>
      </HorizontalFlex>
      <HorizontalFlex>
        <Label primary>Total <br /><Span>/person</Span> </Label>
        <Amount>$ {amount}</Amount>
      </HorizontalFlex>
      <ResetButton
        onClick={handleReset}
      >
        Reset
      </ResetButton>
    </VerticalFlex>
  )
}

export default App;
